import React, { memo } from "react";
import HelperAssignments from "./HelperAssignments";

const HelperAssignmentsTab = ({
  helpersArray,
  i18n,
  renderNoResultsFound,
  closeModal
}) => {

  return (
    <div>
      {helpersArray
        ? <HelperAssignments
            helpersArray={helpersArray}
            i18n={i18n}
            closeModal={closeModal}
          />
        : renderNoResultsFound()}
    </div>
  );
};

export default memo(HelperAssignmentsTab);
